import { default as Skeleton } from '@mui/material/Skeleton';

export const AssignmentsSkeleton = () => (
  <Skeleton data-testid="assignments-skeleton" height={160} sx={{ mt: 10 }} />
);
